import axios from "axios";

import { AccountType } from "shared/types/accounts";

import { JsonResp, unwrapJsonResp } from "../JsonResp";

export interface YoutubeChannel {
  kind: "youtube#channel";
  id: string;
  login: string;
  profilePictureUrl: string;
  snippet: {
    title: string;
    description: string;
  };
}

export async function getYtRedirect(
  reconnect: boolean = false,
  accountId?: string
) {
  let url = "/yt/request_token";
  if (reconnect) {
    const params = new URLSearchParams({ reconnect: "true" });
    if (accountId) params.set("accountId", accountId);
    url = `${url}?${params}`;
  }
  const response = await axios.request<string>({ method: "get", url });
  return response.data;
}

export async function getAvailableYtChannels() {
  const url = new URL(window.location.href);
  const response = await axios.request<JsonResp<YoutubeChannel[]>>({
    method: "get",
    url: `/yt/channels/${url.searchParams.get("sub")}`,
  });
  return unwrapJsonResp(response.data);
}

export async function addYtChannel(channel: YoutubeChannel) {
  const url = new URL(window.location.href);
  const sub = url.searchParams.get("sub");
  const response = await axios.request<JsonResp<AccountType>>({
    method: "post",
    url: `/yt/channels/${sub}/channels/${channel.id}`,
  });
  return unwrapJsonResp(response.data);
}
